import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.section`
  margin: 0 auto auto;
  width: 100%;
  padding: 3em 1.5em 2em;
  flex-grow: 1;
  background-color: #f1f2f6;
`

const RelatedPostsContainer = props => {
  return <Wrapper>{props.children}</Wrapper>
}

export default RelatedPostsContainer
